import { clsx } from 'clsx'
import { CircleAlert, CircleCheck, Info, Loader2, X } from 'lucide-react'
import { useFeedback } from '@/store/feedbackStore'

export function Toasts() {
  const toasts = useFeedback((s) => s.toasts)
  const dismiss = useFeedback((s) => s.dismiss)
  return (
    <div
      aria-live="polite"
      className="pointer-events-none fixed inset-x-0 bottom-0 z-[100] flex flex-col items-center gap-2 p-4 pb-[calc(env(safe-area-inset-bottom)+5rem)] md:pb-6"
    >
      {toasts.map((t) => {
        const Icon = t.tone === 'success' ? CircleCheck : t.tone === 'error' ? CircleAlert : Info
        return (
          <div
            key={t.id}
            role={t.tone === 'error' ? 'alert' : 'status'}
            className="pointer-events-auto flex max-w-md animate-up items-center gap-3 rounded-2xl bg-[#1d2130] py-2.5 pr-2 pl-3.5 text-sm text-white shadow-lg"
          >
            <Icon
              className={clsx(
                'size-4 shrink-0',
                t.tone === 'success' && 'text-green-400',
                t.tone === 'error' && 'text-red-400',
              )}
            />
            <span className="flex-1">{t.message}</span>
            {t.action && (
              <button
                type="button"
                onClick={() => {
                  t.action?.run()
                  dismiss(t.id)
                }}
                className="rounded-lg px-2 py-1 font-semibold text-indigo-300 hover:bg-white/10"
              >
                {t.action.label}
              </button>
            )}
            <button
              type="button"
              aria-label="Dismiss"
              onClick={() => dismiss(t.id)}
              className="rounded-lg p-1 text-white/60 hover:bg-white/10"
            >
              <X className="size-4" />
            </button>
          </div>
        )
      })}
    </div>
  )
}

export function BusyOverlay() {
  const busy = useFeedback((s) => s.busy)
  if (!busy) return null
  return (
    <div
      className="fixed inset-0 z-[90] flex animate-in items-center justify-center bg-black/20 backdrop-blur-[1px]"
      aria-busy
    >
      <div className="flex min-w-56 flex-col items-center gap-3 rounded-2xl border border-line bg-surface px-6 py-5 shadow-lg">
        <Loader2 className="size-6 animate-spin text-accent" />
        <span className="font-medium text-sm">{busy.label}</span>
        {busy.progress !== undefined && (
          <div className="h-1.5 w-44 overflow-hidden rounded-full bg-surface-3">
            <div
              className="h-full rounded-full bg-accent transition-[width]"
              style={{ width: `${Math.round(busy.progress * 100)}%` }}
            />
          </div>
        )}
      </div>
    </div>
  )
}
